import PubSub from "underpub-js";

var CtaForm = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-CtaForm',
	};

	$.extend(true, this.options, options);

};

CtaForm.prototype.init = function() {

	var self = this;

};

export default CtaForm;
